// --------------------------------------------------------------------------
// timeSlider.js
// --------------------------------------------------------------------------
// Uses http://refreshless.com/nouislider/ for time range selection
// --------------------------------------------------------------------------

RN.timeSlider = function() {

  'use strict';

  var timeSlider,
      label,
      lowerHandle,
      upperHandle,
      mobile,
      valueLabels,
      valueInputs,
      startTime,
      endTime;

  function init() {
    timeSlider = byBehaviour('time-slider')[0];

    if(timeSlider){
      initSlider();
    }
  }

  function initSlider (){
    valueLabels = [
          byElement('time-slider-start')[0],
          byElement('time-slider-finish')[0]
        ];
    valueInputs = [
          byElement('time-slider-start-input')[0],
          byElement('time-slider-finish-input')[0]
        ];
    mobile = window.matchMedia("(max-width: 600px)").matches;
    
    startTime = $(valueInputs[0]).data('value') ? $(valueInputs[0]).data('value') : 10.5;
    endTime = $(valueInputs[1]).data('value') ? $(valueInputs[1]).data('value') : 15;

    noUiSlider.create(timeSlider, {
      start: [ startTime, endTime ],
      step: 0.5,
      margin: 1,
      connect: true,
      range: {
        'min': [  9 ],
        'max': [ 18 ]
      },
      pips: {
        mode: 'steps',
        density: 10,
        filter: filterHalfStep,
        format: {
          to: function(value) {
            return formatTime(value);
          }
        }
      }
    });
    lowerHandle = $('.noUi-handle-lower').parent();
    upperHandle = $('.noUi-handle-upper').parent();
     
    if(mobile){
      label = byElement('time-slider-mobile-label');
    }
    else{
      label = byElement('time-slider-label');
      setTimeout(function(){
        updateLabelPosition();
        label[0].style.opacity = 1;
      }, 10);
    }

    timeSlider.noUiSlider.on('update', updateLabelValue);
  }

  function formatTime(value){
    var split = value.toString().split('.'),
        hours,
        minutes,
        ampm,
        formatted;

    if(value > 12.5){
      hours = split[0] - 12;
    }
    else{
      hours = split[0];
    }

    if(split[1] == '50'){
      minutes = ':30';
    } else{
      minutes = '';
    }

    if (value >= 12){
      ampm = 'PM';
    }
    else {
      ampm = 'AM';
    }

    formatted = hours + minutes + ampm;

    return formatted;
  }

  function filterHalfStep(value){
    return value % 1 ? 2 : 1;
  }

  function updateLabelValue(values, handle){
    var time = parseFloat(values[1]) - parseFloat(values[0]),
        text;

    if (time === 1){
      text = time + ' hour'
    }
    else {
      text = time + ' hours'
    }

    label.text(text);
    
    updateValues(values, handle);

    if(!mobile){
      setTimeout(updateLabelPosition, 20);
    }
  }

  function updateLabelPosition(){
    var lower = parseFloat(lowerHandle[0].style.left),
        upper = parseFloat(upperHandle[0].style.left),
        diff = lower + ((upper - lower) / 2);

    label[0].style.left = diff + '%';
  }

  function updateValues(values, handle){
    valueLabels[handle].innerHTML = formatTime(values[handle]);
    valueInputs[handle].value = values[handle];
  }

  return {
    init: init
  };

}();

